import { useOptimizelyFlagContext } from "../providers/OptimizelyFlagProvider.mjs";
const useGetFlag = (flag) => {
  const { decisions } = useOptimizelyFlagContext();
  const decision = decisions[flag] ?? { enabled: false, variationKey: null };
  return decision;
};
export {
  useGetFlag
};
